export const clearStoredAuth = () => {
  if (typeof window === 'undefined') return;

  localStorage.removeItem('authToken');
  localStorage.removeItem('user');
};

export const getTokenPayload = (token: string) => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch {
    return null;
  }
};

export const isTokenExpired = (token: string, bufferMs = 0) => {
  const payload = getTokenPayload(token);

  if (!payload?.exp) {
    return true;
  }

  return payload.exp * 1000 <= Date.now() + bufferMs;
};

export const getStoredAuthToken = () => {
  if (typeof window === 'undefined') return null;

  const token = localStorage.getItem('authToken');
  if (!token) return null;

  if (isTokenExpired(token)) {
    clearStoredAuth();
    return null;
  }

  return token;
};

export const buildAuthHeaders = (
  token?: string | null,
  headers: Record<string, string> = {}
) => {
  if (!token || isTokenExpired(token)) {
    return headers;
  }

  return {
    ...headers,
    Authorization: `Bearer ${token}`
  };
};
